import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'lib-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
	@Output()
	public searchRes: EventEmitter<string>;

	public form: FormControl;

	private debounceSubject = new Subject();

	@Input()
	public placeholder: string;

	@Input()
	public currentValue: string;

	constructor() {
		this.searchRes = new EventEmitter();
	}

	ngOnInit(): void {
		this.form = new FormControl(this.currentValue ?? '');

		this.debounceSubject.pipe(debounceTime(500)).subscribe((value: any) => {
			this.searchRes.emit(value.toLowerCase());
		});
	}

	public searchResult(event: any) {
		this.debounceSubject.next(event.target.value);
	}

	public clearInput(): void {
		this.form.setValue('');
		this.searchRes.emit(this.form.value);
	}
}
